module.exports = __webpack_public_path__ + "media/images/360/healthy-dba115eea97677d7aef2248ae81dba9c.webp";